var FetchReportUrlEnum;
(function (FetchReportUrlEnum) {
    FetchReportUrlEnum["Flash"] = "api_flash_report_list";
    FetchReportUrlEnum["Premium"] = "api_premium_report_list";
})(FetchReportUrlEnum || (FetchReportUrlEnum = {}));
var ReportTypeEnum;
(function (ReportTypeEnum) {
    ReportTypeEnum["Flash"] = "Flash";
    ReportTypeEnum["Premium"] = "Premium";
})(ReportTypeEnum || (ReportTypeEnum = {}));
export { ReportTypeEnum, FetchReportUrlEnum };
